import { render, staticRenderFns } from "./NewContact.vue?vue&type=template&id=5b9cc43f&scoped=true&"
var script = {}
import style0 from "./NewContact.vue?vue&type=style&index=0&id=5b9cc43f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9cc43f",
  null
  
)

export default component.exports